import type { quoteNew as enQuoteNew } from "../en/quoteNew";

export const quoteNew: typeof enQuoteNew = {
  errors: {
    trialEndedWithDate: "Il tuo periodo di prova è terminato il {{date}} — scegli un piano per creare preventivi.",
    trialEndedNoDate: "Il tuo periodo di prova è terminato — scegli un piano per creare preventivi.",
    quotaExceeded:
      "Hai usato tutti i {{cap}} preventivi gratuiti disponibili negli ultimi 30 giorni. Esegui l'upgrade a Starter per preventivi illimitati.",
    pickCompany: "Scegli prima un'azienda.",
    companyGidInvalid: "L'ID azienda deve essere un GID Shopify (gid://shopify/Company/...).",
    buyerEmailRequired: "L'email dell'acquirente è obbligatoria.",
    buyerEmailInvalid: "Inserisci un indirizzo email valido per l'acquirente (es. acquirente@azienda.com).",
    lineRequired: "È richiesta almeno una riga.",
    invalidExpiry: "Data di scadenza non valida.",
    linesPayloadInvalid: "Dati delle righe non validi.",
    addAtLeastOneLine: "Aggiungi almeno una riga.",
    tooManyLines: "Il preventivo supera le 500 righe — suddividilo in preventivi più piccoli.",
    invalidQuantity: "Quantità non valida per {{title}}.",
    invalidQuotePrice: "Prezzo di preventivo non valido per {{title}}.",
    invalidOriginalPrice: "Prezzo originale non valido per {{title}}.",
    createFailed: "Impossibile creare il preventivo. Riprova oppure contatta l'assistenza se il problema persiste.",
  },
  heading: "Nuovo preventivo",
  trialBanner: {
    withDate:
      "Il tuo periodo di prova è terminato il {{date}}. Scegli un piano per creare e inviare preventivi — i tuoi preventivi esistenti restano visibili.",
    noDate:
      "Il tuo periodo di prova è terminato. Scegli un piano per creare e inviare preventivi — i tuoi preventivi esistenti restano visibili.",
    choosePlan: "Scegli un piano",
  },
  upgradeLink: "Esegui l'upgrade a Starter",
  noCompaniesBanner: {
    prefix:
      "Nessuna azienda B2B trovata in questo negozio. Quote Desk richiede almeno un'Azienda B2B a cui assegnare un preventivo —",
    createLink: "creane una qui in circa 20 secondi",
    middle: "(configuriamo noi il contatto e la sede), oppure",
    manualLink: "configurala manualmente nell'admin di Shopify",
  },
  companiesErrorBanner:
    "Non siamo riusciti a elencare le tue aziende B2B. Il B2B potrebbe non essere abilitato su questo negozio, oppure gli scope dell'app non sono ancora stati concessi. Puoi comunque incollare manualmente un GID azienda qui sotto.",
  buyerSection: {
    heading: "Acquirente",
    companyLabel: "Azienda",
    priceListHint:
      "Questa azienda ha un listino prezzi assegnato — i prezzi delle righe qui sotto sono precompilati da esso. Puoi comunque sovrascrivere qualsiasi riga.",
    currencyMismatch:
      "Il listino prezzi ‘{{name}}’ è in {{listCurrency}}, ma questo negozio emette preventivi in {{shopCurrency}} — i prezzi non sono stati applicati automaticamente. Per usare questi prezzi, modifica il listino in modo che corrisponda alla valuta del negozio, oppure crea un listino separato in {{shopCurrency}} per questa azienda.",
    companyGidLabel: "GID azienda",
    companyGidHelp: "Incolla il GID azienda dall'admin di Shopify → Clienti → Aziende (l'URL lo contiene).",
    companyNameLabel: "Nome azienda",
    buyerEmailLabel: "Email acquirente",
    buyerNameLabel: "Nome acquirente",
    expiresAtLabel: "Scadenza (facoltativo)",
  },
  lineItemsSection: {
    heading: "Righe",
    emptyBanner: 'Nessuna riga ancora. Clicca "Scegli prodotti" per selezionarli dal tuo catalogo.',
    skuLabel: "SKU {{sku}}",
    qtyLabel: "Quantità",
    originalPriceLabel: "Prezzo originale",
    quotePriceLabel: "Prezzo di preventivo",
    fromPriceListBadge: "Dal listino prezzi",
    lineTotal: "Riga: {{amount}}",
    pickProducts: "Scegli prodotti",
    addMoreProducts: "Aggiungi altri prodotti",
    subtotal: "Subtotale: {{amount}}",
    remove: "Rimuovi",
    resourcePickerUnavailable: "Il selettore risorse non è disponibile. Apri questa app dall'interno dell'admin di Shopify.",
  },
  notesSection: {
    heading: "Note",
    internalNoteLabel: "Nota interna (non visibile all'acquirente)",
    buyerNoteLabel: "Nota per l'acquirente (visibile nella pagina del preventivo)",
  },
  submit: {
    creating: "Creazione…",
    create: "Crea preventivo",
  },
};
